import React from 'react'
import { CheckboxProps } from './types'
import * as rawStyles from './styles.module.scss'

const Checkbox = React.forwardRef(
    (
        { id, disabled, label, form, className, ...props }: CheckboxProps,
        ref: React.ForwardedRef<HTMLInputElement>,
    ) => {
        const styles: any = rawStyles
        return (
            <div
                key={id}
                id={id}
                className={`${styles['b_checkbox']} ${className || ''}`}
                data-is-disabled={disabled}
                data-form={form}>
                <input
                    className={styles.checkmark}
                    type='checkbox'
                    aria-label='checkbox'
                    ref={ref}
                    {...props}
                />
                {label}
            </div>
        )
    },
)

Checkbox.displayName = 'Checkbox'

export default Checkbox
